import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {
  AddToCartItem,
  Cart,
  Collection,
  Product,
  ProductVariant,
} from '../classes/utility';
import { SEOService } from './seo.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(private seoService: SEOService) {}

  private themeEventsSubject = new Subject<{
    type?: string;
    action?: string;
    payload?: any;
    meta?: any;
  }>();
  public themeEvents: Observable<{
    type?: string;
    action?: string;
    payload?: any;
    meta?: any;
  }> = this.themeEventsSubject.asObservable();

  clear() {
    this.themeEventsSubject.next({ type: 'clear' });
  }

  drawerOpen() {
    this.themeEventsSubject.next({ type: 'drawerOpen' });
  }

  menuOpen() {
    this.themeEventsSubject.next({ type: 'menuOpen' });
  }

  minicartOpen() {
    this.themeEventsSubject.next({ type: 'minicartOpen' });
  }

  searchOpen() {
    this.themeEventsSubject.next({ type: 'searchOpen' });
  }

  countryOpen() {
    this.themeEventsSubject.next({ type: 'countryOpen' });
  }

  accordionOpen(uid: string) {
    this.themeEventsSubject.next({ type: 'accordionOpen', meta: { uid } });
  }

  deployToasts(variantIds: string[], cart: any) {
    this.themeEventsSubject.next({
      type: 'deploy',
      payload: { cart, variantIds },
    });
  }

  viewPage(page: any) {
    this.themeEventsSubject.next({
      action: 'viewPage',
      payload: {
        page,
      },
    });
  }

  viewProduct(product: Product) {
    this.themeEventsSubject.next({
      action: 'viewProduct',
      payload: {
        product,
      },
    });
  }

  viewCollection(collection: Collection) {
    this.themeEventsSubject.next({
      action: 'viewCollection',
      payload: {
        collection,
      },
    });
  }

  addToCart(addToCartItems: AddToCartItem[], cart: Cart) {
    this.themeEventsSubject.next({
      action: 'addToCart',
      payload: {
        addToCartItems,
        cart,
      },
    });
  }

  viewCart(cart: Cart) {
    this.themeEventsSubject.next({
      action: 'viewCart',
      payload: {
        cart,
      },
    });
  }

  startCheckout(cart: Cart) {
    this.themeEventsSubject.next({
      action: 'startCheckout',
      payload: {
        cart,
      },
    });
  }

  addToWishlist(variant: ProductVariant) {
    this.themeEventsSubject.next({
      action: 'addToWishlist',
      payload: {
        variant,
      },
    });
  }

  search(query: string) {
    this.themeEventsSubject.next({
      action: 'search',
      payload: {
        query,
      },
    });
  }

  hexToRgba(hex: any, opacity: any) {
    // Remove the '#' if it's there
    hex = hex.replace('#', '');

    // Parse r, g, b values from the hex string
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Convert opacity from percentage to a decimal
    let alpha = opacity / 100;

    // Return the rgba string
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}
